<template>
  <table class="tableSize flipTable">
    <tr>
      <th class="tableHeader" v-for="(header, n) in headers" :key="n">{{header}}</th>
    </tr>
    <tbody>
      <tr v-for="(contract, index) in contractData" :key="index">
        <td class="sortCenter text">{{contract.ad_knd_nm}}</td>
        <td class="sortCenter text">{{contract.dp_knd_nm}}</td>
        <td class="sortCenter">
          <div class="data_wrap">
            {{parseDataType(contract.contract_imp)}}
          </div>
        </td>
        <td class="sortCenter">
          <div class="data_wrap">
            {{parseDataType(contract.imp_cnt)}}
          </div>
        </td>
        <td class="sortCenter">
          <div class="data_wrap">
            {{parseDataType(contract.click_cnt)}}
          </div>
        </td>
        <td class="sortCenter">
          <div class="data_wrap">
            {{contract.ctr.toFixed(2)}}
          </div>
        </td>
        <td class="sortCenter">
          <div class="data_wrap">
            {{contract.day_rate.toFixed(1)}}
          </div>
        </td>
        <td class="sortCenter">
          <div class="data_wrap">
            {{contract.imp_rate.toFixed(1)}}
          </div>
        </td>
        <td class="sortCenter text">{{parseDataType(contract.budget_amt)}}</td>
      </tr>
      <tr>
        <td colspan="3" class="sortCenter contract_total_text"><b>합계</b></td>
        <th class="sortCenter" v-for="(result, key, n) in contractTotal" :key="n">
          <div class="data_wrap">
            {{parseData(result, key)}}
          </div>
        </th>
      </tr>
    </tbody>
  </table>
</template>

<script>
  import { parseData } from '@/assets/func'
  export default {
    name: 'contractBaseTable',
    props: {
      contractData: Array,
      contractTotal: Object,
      parseDataType: Function
    },
    data () {
      return {
        headers: [
          '광고상품',
          '타겟팅',
          '계약수',
          '노출수',
          '클릭수',
          'CTR(%)',
          '진행률(%)',
          '달성률(%)',
          '총광고비'
        ]
      }
    },
    methods: {
      parseData (data, key) {
        return key === 'day_rate' ? data : parseData(data, key)
      }
    }
  }
</script>

<style scoped>
  .text {
    min-width: 65px;
  }
</style>


// WEBPACK FOOTER //
// ContractBaseTable.vue?385f2d08